/* Olivine AI Skin Plan thank you page, Shopify theme port (FRONT lane).
   Same behaviour as static/thanks.js. Reads ?l= and ?s=, polls <api_base>/api/status/<l> and
   moves the progress bar. Never shows plan content. Copy comes from #skin-plan-thanks-config. */
(function () {
  'use strict';

  var cfgEl = document.getElementById('skin-plan-thanks-config');
  if (!cfgEl) return;
  var C = {};
  try { C = JSON.parse(cfgEl.textContent) || {}; } catch (e) { C = {}; }
  function t(key) { return typeof C[key] === 'string' ? C[key] : ''; }
  function cleanBase(u) {
    u = typeof u === 'string' ? u.trim() : '';
    if (!/^https:\/\/[^\s/]+/.test(u) && !/^http:\/\/(127\.0\.0\.1|localhost)(:\d+)?/.test(u)) return '';
    return u.replace(/\/+$/, '');
  }

  var API_BASE = cleanBase(C.api_base);
  // Preview routing: under ?view=skin-plan* (theme preview of unpublished pages) every internal
  // funnel link stays on the CURRENT path with view=<target suffix>, keeping preview_theme_id and
  // every other query param. Without a view param, links are left exactly as they are.
  function previewHref(href, extra) {
    var here = new URLSearchParams(location.search);
    if ((here.get('view') || '').indexOf('skin-plan') !== 0) return null;
    var u;
    try { u = new URL(href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    var m = u.pathname.match(/\/pages\/(skin-plan[a-z0-9_\u002D]*)\/?$/);
    if (!m) return null;
    u.searchParams.forEach(function (v, k) { if (k !== 'view') here.set(k, v); });
    here.set('view', m[1]);
    Object.keys(extra || {}).forEach(function (k) { here.set(k, extra[k]); });
    return location.pathname + '?' + here.toString();
  }
  function routeFunnelLinks(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('a[href]'), function (a) {
      var to = previewHref(a.getAttribute('href'));
      if (to) a.setAttribute('href', to);
    });
  }

  var POLL_MS = 4000;
  var GIVE_UP_MS = 20 * 60 * 1000;
  var LEAD_RE = /^[A-Za-z0-9_-]{4,64}$/;

  var fill = document.getElementById('bar-fill');
  var barEl = document.getElementById('bar');
  var barText = document.getElementById('bar-text');
  var stateLabel = document.getElementById('gen-state');
  var statusLine = document.getElementById('status-line');

  var params = new URLSearchParams(location.search);
  var BY_TEXT = params.get('s') === '1';
  var COPY = (BY_TEXT ? C.sms : C.email) || {};
  function c(key) { return typeof COPY[key] === 'string' ? COPY[key] : ''; }

  // The plan link from /api/status. Only https on the API host (api_base origin) or a relative /p/
  // path, which is resolved against the API host because the plan page lives there.
  function safePlanUrl(u) {
    if (typeof u !== 'string' || !u || !API_BASE) return '';
    var apiOrigin = new URL(API_BASE).origin;
    if (/^\/p\/[A-Za-z0-9_\u002D]+\/?$/.test(u)) return apiOrigin + u;
    try {
      var p = new URL(u);
      if (p.protocol === 'https:' && p.origin === apiOrigin && p.pathname.indexOf('/p/') === 0 && !p.username && !p.password) return p.href;
    } catch (e) { /* not a URL */ }
    return '';
  }

  var progress = 0.15;
  var started = Date.now();
  var done = false;
  var timer = null;

  function setProgress(p) {
    progress = Math.max(progress, Math.min(1, p));
    fill.style.transform = 'scaleX(' + progress.toFixed(3) + ')';
    barEl.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
  }

  function setLine(strongText, italicText) {
    statusLine.textContent = '';
    var s = document.createElement('strong');
    s.textContent = strongText;
    statusLine.appendChild(s);
    if (italicText) {
      statusLine.appendChild(document.createTextNode(' '));
      var i = document.createElement('i');
      i.textContent = italicText;
      statusLine.appendChild(i);
    }
  }

  function apply(state, planUrl) {
    if (state === 'queued') {
      setProgress(0.15);
      stateLabel.textContent = t('state_building');
      barText.textContent = t('bar_building');
    } else if (state === 'generating') {
      var base = Math.max(progress, 0.3);
      setProgress(base + (0.9 - base) * 0.12);
      stateLabel.textContent = t('state_building');
      barText.textContent = t('bar_building');
    } else if (state === 'ready') {
      done = true;
      setProgress(1);
      stateLabel.textContent = t('state_done');
      var link = safePlanUrl(planUrl);
      if (link) {
        barText.textContent = t('bar_ready_link');
        setLine(t('ready_link_line'), t('also_send_line'));
        var btn = document.getElementById('plan-link');
        if (btn) { btn.href = link; btn.hidden = false; }
      } else {
        barText.textContent = c('ready');
        setLine(c('check'), t('arrive_line'));
      }
    } else if (state === 'held' || state === 'failed') {
      done = true;
      stateLabel.textContent = t('state_late');
      barText.textContent = t('bar_late');
      setLine(t('late_line'), c('later'));
    }
  }

  function leadId() {
    var l = params.get('l') || '';
    return LEAD_RE.test(l) ? l : '';
  }

  function schedule(id) {
    if (done) return;
    if (Date.now() - started > GIVE_UP_MS) return;
    timer = setTimeout(function () { poll(id); }, POLL_MS);
  }

  function poll(id) {
    timer = null;
    if (done) return;
    if (document.hidden) { schedule(id); return; }
    fetch(API_BASE + '/api/status/' + encodeURIComponent(id), { cache: 'no-store', credentials: 'omit', mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && typeof d.state === 'string') apply(d.state, d.plan_url);
        schedule(id);
      })
      .catch(function () { schedule(id); });
  }

  /* ---------- READ THIS box ---------- */
  var toggle = document.querySelector('.readthis-btn');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      document.getElementById('readthis-body').hidden = open;
    });
  }

  /* ---------- video URL fallback ---------- */
  var card = document.getElementById('video-card');
  var url = card && card.getAttribute('data-video-url');
  var play = card && card.querySelector('[data-play]');
  if (play && url && url.indexOf('https://') === 0) {
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'play';
    btn.setAttribute('aria-label', card.getAttribute('data-play-label') || 'Play');
    btn.appendChild(play.firstElementChild.cloneNode(true));
    play.replaceWith(btn);
    btn.addEventListener('click', function () {
      var poster = card.querySelector('img.poster');
      var v = document.createElement('video');
      v.src = url; v.controls = true; v.autoplay = true; v.playsInline = true; v.width = 1280; v.height = 720;
      if (poster) v.poster = poster.currentSrc || poster.src;
      card.textContent = '';
      card.appendChild(v);
    });
  }

  /* ---------- boot ---------- */
  routeFunnelLinks(document);
  if (BY_TEXT) {
    setLine(c('check'), t('arrive_line'));
    var where = document.getElementById('where-text');
    if (where) where.textContent = c('where');
  }
  setProgress(0.15);
  var id = leadId();
  if (id && API_BASE) poll(id);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && id && API_BASE && !done && timer === null && Date.now() - started <= GIVE_UP_MS) poll(id);
  });
})();
